import { Footer, FooterButtons } from '@/design_system/Footer';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

import { ArticleActionProps } from '../ArticleActions';
import { CreateShipmentButton } from '../shared/CreateShipmentButton';

import { ValidateSelfHandledTransitButton } from './ValidateSelfHandledTransitButton';

export const CreateShipmentAction = ({ onActionDone }: ArticleActionProps) => {
  const { article } = useArticleContext();

  const isSelfHandledTransitEnabled = article.selfHandledTransit?.enabled === true;

  return (
    <Footer>
      <FooterButtons>
        <CreateShipmentButton variant={isSelfHandledTransitEnabled ? 'secondary' : 'primary'} />
        {isSelfHandledTransitEnabled && (
          <ValidateSelfHandledTransitButton onActionDone={onActionDone} />
        )}
      </FooterButtons>
    </Footer>
  );
};
